(function (ng) {
  //component definition for the "Initiate a Return" page
  //creates and manages the order lookup to start the return
  //also saves the request state to create the return
  ng.module("evo.returns.initiate.components").component("confirmRequestPage", {
    templateUrl: [
      "TEMPLATES_BASE",
      function (TEMPLATES_BASE) {
        return (
          TEMPLATES_BASE + "returns/initiate/components/confirmRequestPage"
        );
      },
    ],
    bindings: {
      createRequest: "<",
      createResponse: "<",
    },
    controller: [
      "$state",
      "returnAuthorizationService",
      function ($state, returnAuthorizationService) {
        var ctrl = this;

        ctrl.errorCreatingReturnAuthorization = false;
        ctrl.itemsBeingReturned = [];
        ctrl.loading = false;

        //submit the return and redirect to final page
        ctrl.submit = function () {
          ctrl.errorCreatingReturnAuthorization = false;
          ctrl.loading = true;

          //build a request that contains only the items being returned
          var request = ng.extend({}, ctrl.createRequest, {
            Items: ctrl.itemsBeingReturned,
          });

          returnAuthorizationService.createReturnAuthorization(request).then(
            function (response) {
              ctrl.loading = false;

              ng.extend(ctrl.createResponse, response);

              $state.go("initiate.returnAuthorizationSubmittedPage");
            },
            function () {
              ctrl.errorCreatingReturnAuthorization = true;
              ctrl.loading = false;
            }
          );
        };

        ctrl.$onInit = function () {
          if (!ctrl.createRequest.OrderId) {
            $state.go("initiate.initiateReturnPage");
          }

          ctrl.itemsBeingReturned = ctrl.createRequest.Items.filter(function (
            item
          ) {
            return item.ReturnReason;
          });

          dataLayerManager.pushEvoPageType("post purchase (review return)");
        };
      },
    ],
  });
})(angular);
